module.exports = __webpack_public_path__ + "static/media/char.322bafca.png";